
import React, { useEffect, useRef, useState } from "react";
import {
  Autocomplete,
  Backdrop,
  Box,
  createTheme,
  CssBaseline,
  FormControl,
  IconButton,
  InputLabel,
  MenuItem,
  OutlinedInput,
  Paper,
  Select,
  Skeleton,
  TextField,
  ThemeProvider,
  Tooltip,
  Typography,
} from "@mui/material";
import Loader from "../../../components/Loader";
import { toast, ToastContainer } from "react-toastify";
import { common_axios } from "../../../App";
import { useFormik } from "formik";
import Grid from "@mui/material/Grid";
import List from "@mui/material/List";
import Card from "@mui/material/Card";
import CardHeader from "@mui/material/CardHeader";
import ListItem from "@mui/material/ListItem";
import ListItemText from "@mui/material/ListItemText";
import ListItemIcon from "@mui/material/ListItemIcon";
import Checkbox from "@mui/material/Checkbox";
import Button from "@mui/material/Button";
import Divider from "@mui/material/Divider";
import SearchIcon from "@mui/icons-material/Search";
import CancelIcon from "@mui/icons-material/Cancel";
import index from "../../login";
import MenuIcon from "@mui/icons-material/Menu";
import AddCircleRoundedIcon from "@mui/icons-material/AddCircleRounded";
import SendIcon from "@mui/icons-material/Send";
import RestartAltIcon from "@mui/icons-material/RestartAlt";
import { styled } from "@mui/material/styles";
import DeleteIcon from "@mui/icons-material/Delete";
import GroupIcon from "@mui/icons-material/Group";
import Swal from "sweetalert2";
import CheckBoxOutlineBlankIcon from "@mui/icons-material/CheckBoxOutlineBlank";
// import CircleIcon from "@mui/icons-material/Star";
import CircleIcon from "@mui/icons-material/Circle";
export default function RoleManagement() {
  function not(a, b) {
    return a?.filter((value) => b?.indexOf(value) === -1);
  }

  function intersection(a, b) {
    return a?.filter((value) => b?.indexOf(value) !== -1);
  }

  function union(a, b) {
    return [...a, ...not(b, a)];
  }

  const customId1 = "custom-id-yes";

  const Item = styled(Paper)(({ theme }) => ({
    backgroundColor: theme.palette.mode === "dark" ? "#1A2027" : "#fff",
    ...theme.typography.body2,
    padding: theme.spacing(1),
    textAlign: "center",
    color: theme.palette.text.secondary,
  }));

  const ITEM_HEIGHT = 48;
  const ITEM_PADDING_TOP = 8;
  const MenuProps = {
    PaperProps: {
      style: {
        maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
        width: 250,
      },
    },
  };
  const [open, setOpen] = React.useState(false);
  const [checked, setChecked] = React.useState([]);
  // console.log("checked--", checked);
  const [editMenu, setEditMenu] = React.useState(false);
  const [left, setLeft] = React.useState([]);
  const [left1, setLeft1] = React.useState([]);
  const [left2, setLeft2] = React.useState([]);

  const [right, setRight] = React.useState([]);
  const [right1, setRight1] = React.useState([]);
  const [permanentRight1Array, setPermanentRight1Array] = useState([]);

  // console.log("ri--", right1, right);
  let temp = [];
  useEffect(() => {
    for (let i = 0; i < right?.length; i++) {
      if (right[i].menu) {
        // console.log("entered");
        temp.push(right[i]);
        setPermanentRight1Array(temp);
      }
    }
  }, [right]);

  const [reset, setReset] = React.useState([]);
  const [showmapped, setshowmapped] = React.useState(false);
  const [showSearchBar, setshowSearchBar] = React.useState(true);

  const [rolesList, setRolesList] = useState([]);
  const [roles, setRoles] = useState(null);
  const [roles1, setRoles1] = useState(null);
  const [roles2, setRoles2] = useState(null);
  const [indexxMenu, setIndexxMenu] = useState(null);
  const [menu, setmenu] = useState("");
  const [MasterId, setMasterId] = useState("");
  const [SubMenuIntheHouse, setSubMenuIntheHouse] = useState([]);
  const [removeState, setRemoveState] = useState([]);
  const [addMenu, setAddMenu] = useState(null);
  const [removeMenu, setRemoveMenu] = useState([]);

  const leftChecked = intersection(checked, left);
  // console.log("left--", leftChecked);

  const rightChecked = intersection(checked, right);

  const handleToggle = (value, id, roleid, title) => () => {
    if (id == 1 && title == "Mapped" && roleid == 1) {
      if (checked) {
        const currentIndex = checked.indexOf(value);
        const newChecked = [...checked];

        if (currentIndex === -1) {
          newChecked.push(value);
        } else {
          newChecked.splice(currentIndex, 1);
        }

        setChecked(newChecked);
      }
    } else {
      const currentIndex = checked.indexOf(value);
      const newChecked = [...checked];

      if (currentIndex === -1) {
        newChecked.push(value);
      } else {
        newChecked.splice(currentIndex, 1);
      }

      setChecked(newChecked);
    }
  };

  const numberOfChecked = (items) => intersection(checked, items).length;

  const handleToggleAll = (items) => () => {
    if (numberOfChecked(items) === items.length) {
      setChecked(not(checked, items));
    } else {
      setChecked(union(checked, items));
    }
  };

  const handleCheckedRight = () => {
    setRight(right.concat(leftChecked));
    setLeft(not(left, leftChecked));

    setChecked(not(checked, leftChecked));
  };

  const handleCheckedLeft = () => {
    setLeft(left.concat(rightChecked));
    setRight(not(right, rightChecked));
    setChecked(not(checked, rightChecked));
  };
  const handleAllInLeft = () => {
    setLeft(reset);
    setRight([]);
    setChecked(not(checked, rightChecked));
  };

  // console.log({ checked });

  useEffect(() => {
    if (roles) {
      const filterRole = rolesList.filter((el) => {
        return roles.name == el.name;
      });
      // console.log(filterRole, filterRole.menuDetails);

      let statusLeft = [];
      let statusRight = [];

      for (let index = 0; index < filterRole[0]?.menuDetails?.length; index++) {
        const element = filterRole[0].menuDetails[index];
        if (element.status == true) {
          statusRight.push(element);
        } else {
          statusLeft.push(element);
        }
      }

      setLeft(statusLeft);
      // setLeft1(statusLeft);
      setRight(statusRight);
      setRight1(statusRight);

      let disabledRight = [];
      let disabledLeft = [];

      for (let index = 0; index < filterRole[0]?.menuDetails?.length; index++) {
        const element = filterRole[0]?.menuDetails[index];
        if (element?.disabled == true) {
          disabledRight?.push(element);
        } else {
          disabledLeft?.push(element);
        }
      }
    }
  }, [roles]);

  const theme = createTheme({
    components: {
      MuiInputLabel: {
        styleOverrides: {
          asterisk: {
            color: "red",
          },
        },
      },
    },
  });

  // console.log({ addMenu });

  // console.log({ MasterId });

  // console.log({ SubMenuIntheHouse, removeState });

  // console.log(right[0]?.menu, right[0]?.subMenu);

  // console.log(checked[0], right);

  const saveRole = async (value, index) => {
    try {
      setOpen(true);
      if (right[0]?.menu) {
        let newVal = [];

        for (let index = 0; index < addMenu?.length; index++) {
          let element = addMenu[index];

          element.roleId = await roles1?.id;

          // console.log(
          //   "vvvvvvv",

          //   element?.subMenuDetails,
          //   element?.subMenuDetails.length
          // );

          for (
            let indexx = 0;
            indexx < element?.subMenuDetails.length;
            indexx++
          ) {
            let elementt = element?.subMenuDetails[indexx];

            // elementt.roleId = roles1.id;

            element.subMenuDetails[indexx].roleId = await roles1.id;
          }

          // element.subMenuDetails = await newValSub;

          newVal.push(element);
          // newValSub = await [];
        }

        const res = await common_axios.post(`admin/role/v1/add/menu`, {
          // menu: addMenu.map((right) => right.menu).toString(),
          menuDetails: newVal,
          // menuId: Number(addMenu.map((rightt) => rightt.menuId)),
          // roleId: roles1.id,
        });
        if (res.data.statusDescription.statusCode == 200) {
          setOpen(false);
          setRight([]);
          setmenu("");
          setRoles(null);
          setRoles1(null);
          setshowSearchBar(true);
          setChecked([]);
          setLeft(roles1.menuDetails);
          setshowmapped(false);
          setAddMenu(null);
          // await toast.success("Menu saved successfully", {
          //   theme: "colored",
          //   toastId: customId1,
          // });
          Swal.fire({
            icon: "success",
            //  title: "Oops...",
            text: "Menu saved successfully",
            // footer: '<a href="">Why do I have this issue?</a>'
          });
          getRoles();
        } else if (res.data.statusDescription.statusCode == 217) {
          // await toast.error(res.data.statusDescription.description, {
          //   theme: "colored",
          //   toastId: customId1,
          // });
          Swal.fire({
            icon: "error",
            title: "Oops...",
            text: res.data.statusDescription.description,
            // footer: '<a href="">Why do I have this issue?</a>'
          });
          setEditMenu(false);
          setRoles(null);
          setRoles1(null);
          setOpen(false);
          setAddMenu(null);
        }
        // else if (right[0]?.menu && addMenu.length > 1) {
        //   alert("jll");
        //   const res = await common_axios.post(`admin/role/v1/add/menu`, {
        //     // menu: right.map((right) => right.menu).toString(),
        //     roleId: roles1.id,
        //     status: true,
        //     menuDetails: addMenu,
        //   });
        //   if (res.data.statusDescription.statusCode == 200) {
        //     setOpen(false);
        //     setRight([]);
        //     setmenu("");
        //     setRoles(null);
        //     setRoles1(null);
        //     setshowSearchBar(true);
        //     setChecked([]);
        //     setLeft(roles1.menuDetails);
        //     setshowmapped(false);
        //     await toast.success("Menu saved successfully", {
        //       theme: "colored",
        //       toastId: customId1,
        //     });
        //     getRoles();
        //   }
        // }
        else {
          setOpen(false);
          // await toast.error(res.data.statusDescription.description, {
          //   theme: "colored",
          //   toastId: customId1,
          // });
          Swal.fire({
            icon: "error",
            title: "Oops...",
            text: res.data.statusDescription.description,
            // footer: '<a href="">Why do I have this issue?</a>'
          });
        }
      } else if (right[0]?.subMenu) {
        var newSubMenu = SubMenuIntheHouse;

        newSubMenu.subMenuDetails = removeState;

        for (let index = 0; index < newSubMenu.subMenuDetails.length; index++) {
          newSubMenu.subMenuDetails[index].roleId = await roles1.id;
        }

        newSubMenu.roleId = await roles1.id;

        // console.log({ newSubMenu });

        // const res = await common_axios.post(`admin/role/v1/add/sub-menu`, {
        //   subMenu: right.map((right) => right.subMenu).toString(),
        //   roleId: roles1.id,
        //   subMenuId: right.map((right) => right.subMenuId).toString(),
        //   masterMenuId: MasterId,
        //   menuId: indexxMenu,
        //   status: true,
        // });
        // if (res.data.statusDescription.statusCode == 200) {
        //   setOpen(false);
        //   setRight([]);
        //   setmenu("");
        //   setRoles(null);
        //   setRoles1(null);
        //   setshowSearchBar(true);
        //   setLeft(roles1.menuDetails);
        //   setshowmapped(false);
        //   setChecked([]);
        //   await toast.success("Submenu saved successfully", {
        //     theme: "colored",
        //     toastId: customId1,
        //   });
        //   getRoles();
        // } else {
        //   setOpen(false);
        //   await toast.error(res.data.statusDescription.description, {
        //     theme: "colored",
        //     toastId: customId1,
        //   });
        // }

        const res = await common_axios.post(`admin/role/v1/add/menu`, {
          // menu: addMenu.map((right) => right.menu).toString(),
          menuDetails: [newSubMenu],
          // menuId: Number(addMenu.map((rightt) => rightt.menuId)),
          // roleId: roles1.id,
        });
        if (res.data.statusDescription.statusCode == 200) {
          setOpen(false);
          setRight([]);
          setmenu("");
          setRoles(null);
          setRoles1(null);
          setshowSearchBar(true);
          setChecked([]);
          setLeft(roles1.menuDetails);
          setshowmapped(false);
          setAddMenu(null);

          // await toast.success("Menu saved successfully", {
          //   theme: "colored",
          //   toastId: customId1,
          // });
          Swal.fire({
            icon: "success",
            //  title: "Oops...",
            text: "Menu saved successfully",
            // footer: '<a href="">Why do I have this issue?</a>'
          });
          getRoles();
        } else if (res.data.statusDescription.statusCode == 217) {
          // await toast.error(res.data.statusDescription.description, {
          //   theme: "colored",
          //   toastId: customId1,
          // });
          Swal.fire({
            icon: "error",
            title: "Oops...",
            text: res.data.statusDescription.description,
            // footer: '<a href="">Why do I have this issue?</a>'
          });
          setRoles(null);
          setRoles1(null);
          setOpen(false);
          setAddMenu(null);
          setEditMenu(false);
        } else {
          setOpen(false);
          // await toast.error("Console", {
          //   theme: "colored",
          //   toastId: customId1,
          // });
          Swal.fire({
            icon: "error",
            title: "Oops...",
            text: res.data.statusDescription.description,
            // footer: '<a href="">Why do I have this issue?</a>'
          });
        }
      }
    } catch (error) {
      setOpen(false);
      // console.log(error);
      // await toast.error("Something went wrong!! Please try again later", {
      //   theme: "colored",
      //   toastId: customId1,
      // });
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: "Please Check Your Network",
        // footer: '<a href="">Why do I have this issue?</a>'
      });
    }
  };

  const removeSubmenu = async () => {
    try {
      setOpen(true);

      if (left[0].subMenu) {
        const res = await common_axios.post(
          `admin/role/v1/remove/sub-menu`,

          {
            id: removeState?.map((leftt) => leftt.id).toString(),
            // roleId: roles1.id,
            // menuId: indexxMenu,
          }
        );

        if (res.data.statusDescription.statusCode == 200) {
          setOpen(false);
          setRight([]);
          setRoles(null);
          setmenu("");
          setRoles1(null);
          setshowSearchBar(true);
          setChecked([]);
          setLeft(roles1.menuDetails);
          setshowmapped(false);
          setRemoveState([]);
          setRemoveMenu([]);
          setAddMenu(null);
          // await toast.success("Sub-Menu removed successfully", {
          //   theme: "colored",
          //   toastId: customId1,
          // });
          Swal.fire({
            icon: "success",
            //  title: "Oops...",
            text: "Sub-Menu removed successfully",
            // footer: '<a href="">Why do I have this issue?</a>'
          });
          getRoles();
        } else {
          setOpen(false);
          Swal.fire({
            icon: "error",
            title: "Oops...",
            text: res.data.statusDescription.description,
            // footer: '<a href="">Why do I have this issue?</a>'
          });
        }
      } else if (left[0].menu) {
        const res = await common_axios.post(
          `admin/role/v1/remove/menu`,

          {
            id: removeMenu?.map((remove) => remove?.id).toString(),
            // roleId: roles1.id,
            // menuId: indexxMenu,
          }
        );

        if (res.data.statusDescription.statusCode == 200) {
          setOpen(false);
          setRight([]);
          setRoles(null);
          setmenu("");
          setRoles1(null);
          setshowSearchBar(true);
          setChecked([]);
          setLeft(roles1.menuDetails);
          setshowmapped(false);
          setRemoveState([]);
          setRemoveMenu([]);
          setAddMenu(null);
          Swal.fire({
            icon: "success",
            //  title: "Oops...",
            text: "Menu removed successfully",
            // footer: '<a href="">Why do I have this issue?</a>'
          });
          getRoles();
        } else {
          setOpen(false);
          Swal.fire({
            icon: "error",
            title: "Oops...",
            text: res.data.statusDescription.description,
            // footer: '<a href="">Why do I have this issue?</a>'
          });
        }
      }
    } catch (error) {
      setOpen(false);
      // console.log(error);
      // await toast.error("Something went wrong!! Please try again later", {
      //   theme: "colored",
      //   toastId: customId1,
      // });
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: "Please Check Your Network",
        // footer: '<a href="">Why do I have this issue?</a>'
      });
    }
  };

  const customList = (title, items, isLeft) => {
    // console.log("dfgd--", isLeft);

    return (
      <Card>
        <CardHeader
          className="ms-2"
          sx={{ px: 2, py: 1, fontSize: "16px" }}
          title={
            <div className="d-flex justify-content-between align-items-center">
              <h4>{title}</h4>

              <h6>{menu}</h6>
            </div>
          }
          subheader={`${numberOfChecked(items)}/${items?.length} selected`}
        />
        <Divider />
        <List
          sx={{
            height: 300,
            bgcolor: "background.paper",
            overflow: "auto",
          }}
          dense
          component="div"
          role="list"
        >
          {items?.map((value, index) => {
            {/* console.log("value--", items); */}
            if (value.menu) {
              const labelId = `transfer-list-all-item-${value}-label`;

              return (
                <ListItem
                  key={value.id}
                  role="listitem"
                  button
                  disabled={
                    roles?.id == 1
                      ? right1.some((age) => {
                          // console.log("age--", age?.menu, value?.menu);
                          return age?.menu == value?.menu;
                        })
                      : false
                    // roles1?.id == 1 &&
                    // title == `Mapped` &&
                    // value.roleId == 1
                  }
                  onClick={handleToggle(
                    value,
                    roles1?.id,
                    value?.roleId,
                    title
                  )}
                >
                  <ListItemIcon>
                    {isLeft == true ? (
                      <Checkbox
                        onClick={() => {
                          // setChecked([]);
                          let temp = [...checked];
                          temp.push(value);
                          setChecked(temp);
                        }}
                        disabled={
                          roles1?.id == 1 &&
                          title == `Mapped` &&
                          value.roleId == 1
                        }
                        checked={checked.indexOf(value) !== -1}
                        tabIndex={-1}
                        disableRipple
                        inputProps={{
                          "aria-labelledby": labelId,
                        }}
                      />
                    ) : isLeft == false && roles?.id == 1 ? (
                      <Checkbox
                        icon={
                          right1.some((age) => {
                            // console.log("age--", age?.menu, value?.menu);
                            return age?.menu == value?.menu;
                          }) ? (
                            <CircleIcon />
                          ) : (
                            <CheckBoxOutlineBlankIcon />
                          )
                        }
                        onClick={(e) => {
                          // setChecked([]);

                          let temp = [...checked];

                          temp.push(value);
                          setChecked(temp);
                        }}
                        // disabled={
                        //   right1.some((age) => {
                        //     console.log("age--", age?.menu, value?.menu);
                        //     return age?.menu == value?.menu;
                        //   })
                        //   // roles1?.id == 1 &&
                        //   // title == `Mapped` &&
                        //   // value.roleId == 1
                        // }
                        checked={checked.indexOf(value) !== -1}
                        tabIndex={-1}
                        disableRipple
                        inputProps={{
                          "aria-labelledby": labelId,
                        }}
                      />
                    ) : (
                      <Checkbox
                        onClick={() => {
                          setChecked([]);
                        }}
                        // disabled={
                        //   roles1?.id == 1 &&
                        //   title == `Mapped` &&
                        //   value.roleId == 1
                        // }
                        checked={checked.indexOf(value) !== -1}
                        tabIndex={-1}
                        disableRipple
                        inputProps={{
                          "aria-labelledby": labelId,
                        }}
                      />
                    )}
                  </ListItemIcon>
                  <ListItemText
                    onClick={() => {
                      setChecked([]);
                    }}
                    sx={{
                      disabled:
                        roles1?.id == 1 && title == "Mapped" ? "none" : null,
                    }}
                    // disabled={roles1?.id == 1 && title == "Mapped"}
                    disableTypography={true}
                    disabled={true}
                    id={labelId}
                    primary={value.menu}
                    secondary={
                      value?.roleId == 1
                        ? " (SuperAdmin)"
                        : value?.roleId == 2
                        ? " (Admin)"
                        : value?.roleId == 3
                        ? " (Reseller)"
                        : value?.roleId == 4
                        ? " (User)"
                        : " (New User)"
                    }
                  />

                  <Tooltip
                    title={`Expand submenu for ${value.menu}`}
                    placement="top"
                  >
                    <IconButton
                      color="primary"
                      aria-label="upload picture"
                      component="label"
                      onClick={() => {
                        // console.log({ index });
                        setEditMenu(true);

                        let statusLeft = [];
                        let statusRight = [];

                        if (title == `Available`) {
                          for (
                            let indexx = 0;
                            indexx < left[index]?.subMenuDetails.length;
                            indexx++
                          ) {
                            const element = left[index]?.subMenuDetails[indexx];
                            // console.log(
                            //   { indexx, index },
                            //   value.roleId,
                            //   element.roleId,
                            //   roles1.id
                            // );

                            if (
                              element.status == true &&
                              element.roleId == roles1.id
                            ) {
                              statusRight.push(element);
                            } else {
                              statusLeft.push(element);
                            }
                          }
                        } else {
                          for (
                            let indexx = 0;
                            indexx < right[index]?.subMenuDetails.length;
                            indexx++
                          ) {
                            const element =
                              right[index]?.subMenuDetails[indexx];
                            if (
                              element.status == true &&
                              element.roleId == roles1.id
                            ) {
                              statusRight.push(element);
                            } else {
                              statusLeft.push(element);
                            }
                          }
                        }

                        // console.log({ statusLeft, statusRight, checked });
                        // console.log(value?.subMenuDetails[0].masterMenuId);

                        setLeft(statusLeft);
                        setRight(statusRight);
                        setIndexxMenu(value?.id);
                        setmenu(value?.menu);
                        setMasterId(value?.subMenuDetails[0]?.masterMenuId);
                        setSubMenuIntheHouse(value);
                        setTimeout(() => {
                          setChecked([]);
                        }, 500);
                      }}
                    >
                      <AddCircleRoundedIcon />
                    </IconButton>
                  </Tooltip>
                </ListItem>
              );
            } else {
              const labelId = `transfer-list-all-item-${value}-label`;
              {/* console.log("value2--", value); */}
              return (
                <ListItem
                  key={value.id}
                  role="listitem"
                  // disabled={roles1?.id == 1 && title == "Mapped"}
                  // disabled={
                  //   roles?.id == 1
                  //     ? right?.some((age) => {
                  //         console.log("age12--", age?.subMenu, value?.subMenu);
                  //         return age?.subMenu == value?.subMenu;
                  //       })
                  //     : false
                  //   // roles1?.id == 1 &&
                  //   // title == `Mapped` &&
                  //   // value.roleId == 1
                  // }

                  disabled={
                    value?.status == true ? true : false
                    // roles1?.id == 1 &&
                    // title == `Mapped` &&
                    // value.roleId == 1
                  }
                  button
                  onClick={handleToggle(value)}
                >
                  <ListItemIcon>
                    {title == `Available` ? (
                      <Checkbox
                        onClick={() => {
                          // console.log(index);
                        }}
                        checked={checked.indexOf(value) !== -1}
                        tabIndex={-1}
                        disableRipple
                        inputProps={{
                          "aria-labelledby": labelId,
                        }}
                      />
                    ) : roles?.id == 4 ? (
                      <Checkbox
                        onClick={(e) => {
                          // setChecked([]);

                          let temp = [...checked];

                          temp.push(value);
                          setChecked(temp);
                        }}
                        checked={checked.indexOf(value) !== -1}
                        tabIndex={-1}
                        // disableRipple
                        inputProps={{
                          "aria-labelledby": labelId,
                        }}
                      />
                    ) : (
                      <Checkbox
                        // icon={
                        //   right?.some((dataa) => {
                        //     console.log(
                        //       "age24--",
                        //       dataa?.status,
                        //       value?.status
                        //     );

                        //     return dataa?.status == true;
                        //   }) ? (
                        //     <CircleIcon />
                        //   ) : (
                        //     <CheckBoxOutlineBlankIcon />
                        //   )
                        // }

                        icon={
                          value?.status == true ? (
                            <CircleIcon />
                          ) : (
                            <CheckBoxOutlineBlankIcon />
                          )
                        }
                        onClick={() => {
                          // console.log(index);
                        }}
                        checked={checked.indexOf(value) !== -1}
                        tabIndex={-1}
                        disableRipple
                        inputProps={{
                          "aria-labelledby": labelId,
                        }}
                      />
                    )}
                  </ListItemIcon>
                  <ListItemText id={labelId} primary={value.subMenu} />
                </ListItem>
              );
            }
          })}
          <ListItem />
        </List>
      </Card>
    );
  };

  // console.log({ addMenu });
  const fetchUser = async () => {
    try {
      setOpen(true);
      const res = common_axios(`admin/v1/roles/list?roleId=${roles1?.id}`);
      const res1 = common_axios(`/admin/v1/menu/list/?roleId=${roles1?.id}`);

      await Promise.all([res, res1]).then((values) => {
        // console.log({ values });
        if (
          values[0].data.statusDescription.statusCode == 200 &&
          values[1].data.statusDescription.statusCode == 200
        ) {
          // console.log(values[0].data?.menuList);
          // setData1(values[0].data.listResellerNames);
          setLeft(values[1].data?.menuList);
          setLeft2(values[1].data?.menuList);

          setOpen(false);
        } else {
          setOpen(false);
          // toast.error(values[0].data.statusDescription.statusMessage, {
          //   theme: "colored",
          //   toastId: customId1,
          // });
          // Swal.fire({
          //   icon: "error",
          //   title: "Oops...",
          //   text: values[0].data.statusDescription.statusMessage,
          //   // footer: '<a href="">Why do I have this issue?</a>'
          // });
        }
      });
    } catch (error) {
      setOpen(false);
      // console.log(error);
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: "Please Check Your Network",
        // footer: '<a href="">Why do I have this issue?</a>'
      });
    }
  };

  const getRoles = async () => {
    try {
      setOpen(true);
      const res = await common_axios(`admin/v1/roles/list/all`);
      if (res.data.statusDescription.statusCode == 200) {
        setOpen(false);
        setRolesList(res.data.roleList);
      } else {
        setOpen(false);
        // await toast.error(res.data.statusDescription.description, {
        //   theme: "colored",
        // });
        // Swal.fire({
        //   icon: "error",
        //   title: "Oops...",
        //   text: res.data.statusDescription.description,
        //   // footer: '<a href="">Why do I have this issue?</a>'
        // });
      }
    } catch (error) {
      setOpen(false);
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: "Please Check Your Network",
        // footer: '<a href="">Why do I have this issue?</a>'
      });
    }
  };

  useEffect(async () => {
    await getRoles();
  }, []);

  React.useEffect(async () => {
    if (roles1?.id != undefined) {
      fetchUser();
    }
  }, [roles1?.id]);

  // console.log(rolesList.id);

  const addUsermodal = () => {
    modalAddUser.current.click();
  };
  // console.log({ roles1 });
  const modalAddUser = useRef(null);
  const modalAddUserClose = useRef(null);
  return (
    <div className="container-fluid">
      <Backdrop
        sx={{
          transform: "translateZ(0)",
          color: "#fff",
          zIndex: (theme) => theme.zIndex.drawer + 1,
        }}
        open={open}
      >
        <Loader />
      </Backdrop>
      <ToastContainer autoClose={6000} />

      <div class="card mb-3 mt-4">
        <div class="card-header p-3 pt-2">
          <div class="icon icon-lg icon-shape bg-gradient-primary shadow-primary text-center border-radius-xl mt-n4 position-absolute">
            <GroupIcon sx={{ color: "white", fontSize: "33px" }} />
          </div>
          <div
            class="d-flex justify-content-between pt-1"
            style={{ marginLeft: "76px" }}
          >
            <div className="fw-bold">Manage Roles</div>
          </div>
        </div>
        <ThemeProvider theme={theme}>
          <div class="card-body">
            <div className="card shadow-none border bg_blue">
              <span className="badge rounded-pill bg-primary mt-n3 ms-5">
                Manage Roles
              </span>

              <div className="container">
                <div className="row" id="rw_51">
                  <div className="col-md-12 ms-3 mt-3 mb-3">
                  <div class="d-flex justify-content-between align-items-center roleType">

                      <Autocomplete
                        disablePortal
                        size="small"
                        className=""
                        id="combo-box-demo"
                        options={rolesList}
                        getOptionLabel={(option) => `${option.name}`}
                        name="roleType"
                        value={roles}
                        onChange={(e, value) => {
                          setRoles(value);
                          setRoles1(value);
                          setRoles2(value?.menuDetails);
                          setshowSearchBar(true);

                          // getMenus();
                          let statusLeft = [];
                          let statusRight = [];

                          for (let index = 0; index < roles2?.length; index++) {
                            if (roles2[index].status == true) {
                              statusRight.push(index);
                            } else {
                              statusLeft.push(index);
                            }
                          }
                          // console.log({ statusLeft });
                        }}
                        renderInput={(params) => (
                          <TextField
                            required
                            {...params}
                            label="Select Role Type"
                          />
                        )}
                      />
                      {/* {showSearchBar == true && ( */}
                      <IconButton
                        color="primary"
                        aria-label="upload picture"
                        disabled={roles?.name == null}
                        component="label"
                        onClick={() => {
                          setshowmapped(true);
                          setRight(right1);
                          setshowSearchBar(false);
                          if (roles1.id != undefined) {
                            fetchUser();
                          }
                        }}
                      >
                        <SearchIcon />
                      </IconButton>
                      {/* )} */}
                    </div>
                  </div>

                  <div className="col-md-6"></div>
                  <div className="border_btm"></div>
                  {roles?.name != null && roles1?.name != null ? (
                    <>
                      <div className="row">
                        <div className="w-100 text-start">
                          <Grid
                            container
                            spacing={2}
                            justifyContent="center"
                            alignItems="center"
                          >
                            <Grid md={5} item>
                              {/* <Typography style={{ marginLeft: "375px" }}>
                                {menu}
                              </Typography> */}

                              {customList(`Available`, left)}

                              {/* {customList(`Available ${menu}`, left)} */}
                            </Grid>
                            <Grid md={2} item>
                              <Grid
                                container
                                direction="column"
                                alignItems="center"
                              >
                                <Button
                                  style={
                                    leftChecked?.length > 0
                                      ? {
                                          background: "#3f9143",
                                          my: 0.5,
                                          color: "white",
                                          marginBottom: "12.5px",
                                        }
                                      : {
                                          // color: "white",
                                          // null
                                          marginBottom: "12.5px",
                                          // my: 0.5,
                                        }
                                  }
                                  variant="outlined"
                                  size="small"
                                  onClick={() => {
                                    handleCheckedRight();
                                    if (checked[0].menu == undefined || "") {
                                      setRemoveState([...checked]);
                                    }
                                    setAddMenu(checked);
                                  }}
                                  disabled={leftChecked?.length === 0}
                                  aria-label="move selected right"
                                >
                                  Add &gt;
                                </Button>
                                <Button
                                  style={
                                    rightChecked?.length > 0
                                      ? {
                                          background: "#f9442f",
                                          my: 0.5,
                                          color: "white",
                                          marginBottom: "12.5px",
                                        }
                                      : {
                                          // color: "white",
                                          marginBottom: "12.5px",
                                        }
                                  }
                                  variant="outlined"
                                  size="small"
                                  onClick={() => {
                                    handleCheckedLeft();
                                    setRemoveState(checked);
                                    if (checked[0].menu == undefined || "") {
                                      setRemoveState([...checked]);
                                    }
                                    setRemoveMenu(checked);
                                  }}
                                  disabled={rightChecked?.length === 0}
                                  aria-label="move selected left"
                                >
                                  &lt; Remove
                                </Button>

                                <Button
                                  onClick={() => {
                                    setRight(right1);
                                    setChecked([]);
                                    setLeft(left2);
                                    setEditMenu(false);
                                    setmenu("");
                                    setRemoveState([]);
                                    setRemoveMenu([]);
                                    setMasterId("");
                                    setAddMenu(null);
                                  }}
                                  disabled={right1?.length === 0}
                                  className="mb-2 resetBtn_UP"
                                  variant="contained"
                                  size="small"
                                  startIcon={<RestartAltIcon />}
                                >
                                  Reset
                                </Button>

                                {editMenu && (
                                  <Button
                                    onClick={() => {
                                      // setRight(right1);
                                      setRight(permanentRight1Array);

                                      setEditMenu(false);
                                      setLeft(left2);
                                      setChecked([]);
                                      setmenu("");
                                      setRemoveState([]);
                                      setRemoveMenu([]);
                                      setMasterId("");
                                      setAddMenu(null);
                                    }}
                                    variant="contained"
                                    size="small"
                                    startIcon={<MenuIcon />}
                                  >
                                    Edit Menu
                                  </Button>
                                )}
                              </Grid>
                            </Grid>
                            <Grid md={5} item>
                              {/* <Item style={{ alignItems: "right" }}>
                                {menu}
                              </Item> */}

                              {customList(`Mapped`, right, false)}
                            </Grid>
                          </Grid>
                        </div>
                      </div>
                      <div className="d-flex justify-content-between align-items-center">
                        {/* <div className="text-end"> */}
                        <Button
                          sx={{ background: "#f9442f" }}
                          className="mb-2"
                          onClick={() => {
                            // saveRole();
                            removeSubmenu();
                          }}
                          disabled={
                            removeState?.length === 0 ||
                            removeMenu?.length === 0
                          }
                          variant="contained"
                          // endIcon={<DeleteIcon />}
                        >
                          Remove
                        </Button>
                        <Button
                         sx={{ background: "#3f9143" }}
                          className="mb-2 "
                          onClick={() => {
                            saveRole();
                            // removeSubmenu();
                          }}
                          // disabled={right?.length === 0}
                          disabled={addMenu?.length == null}
                          variant="contained"
                          // endIcon={<SendIcon />}
                        >
                          Save
                        </Button>
                        {/* </div> */}
                        {/* <div className="text-start"> */}

                        {/* </div> */}
                      </div>
                    </>
                  ) : null}
                </div>
              </div>
            </div>
          </div>
        </ThemeProvider>
      </div>
    </div>
  );
}
